import {
  BillingInformation,
  getRoutingIdType,
  formatRoutingId,
} from '@app/api';
import { formatVat } from '@app/i18n';

const billingInformationToArray = (
  billingInformation: BillingInformation,
  addressOnly?: boolean,
) => {
  const routingIdType = getRoutingIdType(billingInformation);

  return [
    addressOnly ? undefined : billingInformation.billingOrganization,
    billingInformation.billingAddress?.line1,
    billingInformation.billingAddress?.line2,
    [
      billingInformation.billingAddress?.postalCode,
      billingInformation.billingAddress?.city,
      billingInformation?.billingAddress?.country,
    ]
      .filter(Boolean)
      .join(' '),
    billingInformation.email,
    ' ',
    billingInformation.vatNumber && !addressOnly
      ? `VAT: ${formatVat(billingInformation.vatNumber)}`
      : undefined,
    billingInformation.routingId && !addressOnly
      ? `${routingIdType}: ${formatRoutingId(
          routingIdType,
          billingInformation.routingId,
        )}`
      : undefined,
    billingInformation.locale && !addressOnly
      ? `LOCALE: ${billingInformation.locale}`
      : undefined,
  ];
};

export const billingInformationToString = (
  billingInformation: BillingInformation,
  addressOnly?: boolean,
) => {
  return billingInformationToArray(billingInformation, addressOnly)
    .filter(Boolean)
    .join('\n');
};
